





































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  UserOnboardingSteps,
  UserOnboardingStepKey
} from "@/shared/types";
import CurrentEmployer from "@/employer/components/shared/CurrentEmployer.vue";
import ProgressIndicator from "@/shared/components/ProgressIndicator.vue";
import Logo from "@/shared/components/Logo.vue";
import * as RouteNames from "@/employee/route-names";
import { Location } from "vue-router";
import { useUserStore } from "@/shared/store/user";
import { useWizardStore } from "@/employee/store/wizard";
import { useFdicStore } from "@/shared/store/fdic";
import Fdic from "@/shared/components/Fdic.vue";

const employerHsaSteps = [ "ACCOUNT CREATION", "EMPLOYER DETAILS", "PLAN DETAILS", "PAYROLL CYCLE SETUP", "FINISH" ];

@Component({
  components: {
    ProgressIndicator,
    CurrentEmployer,
    Logo,
    Fdic
  }
})
export default class OnboardingHeader extends Vue {
  userStore = useUserStore();
  wizardStore = useWizardStore();
  fdicStore = useFdicStore();

  @Prop()
  portalType: string;

  @Prop()
  step: number;

  @Prop()
  stepKey: "" | UserOnboardingStepKey;

  @Prop()
  hideProgressIndicator: boolean;

  get employeePortal (): boolean {
    return this.portalType === "employee";
  }

  get isClaimAccountOnboarding (): boolean {
    return this.wizardStore.shownStatuses &&
        this.wizardStore.shownStatuses.some(s => s.step === UserOnboardingSteps.ClaimAccountTerms);
  }

  get selectedStepIndex (): number {
    if (this.stepKey) {
      return this.wizardStore.onboardingStepIndex(this.stepKey);
    }

    return this.step;
  }

  get calculatedStep (): number {
    return this.selectedStepIndex + 1;
  }

  get progressBarItems (): string[] {
    return (this.employeePortal) ? this.wizardStore.shownStatuses.map(s => s.label) : employerHsaSteps;
  }

  get showCreateAccountLink (): boolean {
    return !this.employeePortal;
  }

  get displayName (): string {
    if (!this.userStore.currentUser.displayName.trim()) {
      return "New User";
    }

    return this.userStore.currentUser.displayName;
  }

  get itemLink (): (index: number) => string | Location {
    if (!this.wizardStore.shownStatuses || this.wizardStore.shownStatuses.length === 0) {
      return null;
    }

    return index => {
      const stepKey = this.wizardStore.shownStatuses[index].stepKey;
      return {
        name: RouteNames.NamedOnboarding,
        params: {
          stepKey
        }
      };
    };
  }
}

